export default function RapprochementRevision() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-8 px-6 py-10 font-sans text-slate-900">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">Rapprochement</h1>
        <p className="mt-1 text-sm text-slate-500">Rapprochement bancaire - À venir</p>
      </div>
      <div className="overflow-hidden rounded-lg bg-white shadow-[0_1px_3px_rgba(15,23,42,0.06),0_4px_24px_rgba(15,23,42,0.04)]">
        <div className="px-8 py-12">
          <p className="text-sm text-slate-500">Rapprochement bancaire - À venir</p>
        </div>
      </div>
    </div>
  );
}
